import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import BlogPage from './pages/BlogPage';
import SinglePostPage from './pages/SinglePostPage';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage'; // <-- 1. IMPORT THE NEW PAGE

function App() {
  return (
    <div className="w-full">
      {/* Navbar stays on every page */}
      <Navbar />

      {/* Floating social bar stays on every page */}
      <div className="fixed right-4 top-1/2 -translate-y-1/2 z-50 flex flex-col space-y-4">
        {/* Instagram Link */}
        <a href="https://www.instagram.com/techpackcreators" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-600 transition text-2xl">
          <span className="sr-only">Instagram</span>
          <i className="fab fa-instagram"></i>
        </a>
        
        {/* Facebook Link */}
        <a href="https://www.facebook.com/share/17N63vNP52/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-600 transition text-2xl">
          <span className="sr-only">Facebook</span>
          <i className="fab fa-facebook"></i>
        </a>
              
        {/* Email Link */}
        <a href="mailto:techpackcreators@gmail.com" className="text-gray-500 hover:text-blue-600 transition text-2xl">
          <span className="sr-only">Email</span>
          <i className="fas fa-envelope"></i>
        </a>
      </div>
      {/* --- END OF SOCIAL BAR --- */}

      {/* The Routes control which page is shown */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<SinglePostPage />} />
        <Route path="/contact" element={<ContactPage />} /> {/* <-- 2. ADD THE NEW ROUTE */}
      </Routes>

      {/* Footer stays on every page */}
      <Footer />
    </div>
  );
}

export default App;